define('views/base/view',['require','underscore','ejs','chaplin','text!templates/shared/form-error-messages.ejs','i18n','moment','helpers/application'],function(require) {
    'use strict';

    var _ = require('underscore'),
            ejs = require('ejs'),
        Chaplin = require('chaplin');

    require('text!templates/shared/form-error-messages.ejs');

    var helpers = _.defaults({
        _: _,
        i18n: require('i18n'),
        moment: require('moment')
    },
        require('helpers/application')
    );

    var View = Chaplin.View.extend({

        windowResize: false,

        initialize: function() {
            Chaplin.View.prototype.initialize.apply(this, arguments);

            if (this.windowResize) {
                // console.log('VIEW ON WINDOW RESIZE');
                this._onWindowResize = _.bind(this.onWindowResize, this);
                $(window).resize(this._onWindowResize);
                this.on('addedToDOM', this._onWindowResize);
            }

        },

        onWindowResize: function() {
            // console.log('VIEW WINDOW RESIZED');
            this.model.trigger('resize');
        },

        dispose: function() {
            if (this.disposed) { return; }

            if (this._onWindowResize) {
                // console.log('VIEW OFF WINDOW RESIZE');
                $(window).off('resize', this._onWindowResize);
            }

            Chaplin.View.prototype.dispose.apply(this, arguments);
        },

        getTemplateFunction: function() {
            var template = this.template,
                templateFunc = this.constructor.templateFunc || null;

            if (!templateFunc) {
                if (_.isString(template)) {
                    templateFunc = ejs.compile(template);

                    this.constructor.templateFunc = templateFunc;
                } else {
                    templateFunc = template;
                }
            }

            return templateFunc;
        },

        getTemplateData: function() {
            var object = Chaplin.View.prototype.getTemplateData.apply(this, arguments);
            var user = Chaplin.mediator.user;

            if (user) {
                object.currentUser = user.toJSON();
                object.isClientSB = user.isClientSB();
            }

            return _.defaults(object, helpers);
        }

    });

    return View;
});

